import React from 'react';
// import React, { useState, useRef } from 'react';
import './HomePage.css';
import HomePageSlide1 from '../components/HomePageSlides/HomePageSlide1';
// import HomePageSlide2 from '../components/HomePageSlides/HomePageSlide2';
// import HomePageSlide3 from '../components/HomePageSlides/HomePageSlide3';

const HomePage = () => {
  return (
    <div className="vertical-slider">
      <div className="slider-content">
        <div className="slide"><HomePageSlide1/></div>
        {/* <div className="slide"><HomePageSlide2/></div> */}
        {/* <div className="slide"><HomePageSlide3/></div> */}
      </div>
    </div>
  );
};

export default HomePage;